<app-online-header *ngIf="displayForAdmin" title="צט בוט"></app-online-header>
<div *ngIf="displayForAdmin" class="online-content-cube-wrapper">
<app-chat-bot-inner></app-chat-bot-inner>
</div>

<app-chat-bot-inner *ngIf="!displayForAdmin"></app-chat-bot-inner>
<div class="backdrop"></div>